import { render, staticRenderFns } from "./SmOption.vue?vue&type=template&id=3d3f5b5e&scoped=true&"
import script from "./SmOption.vue?vue&type=script&lang=ts&"
export * from "./SmOption.vue?vue&type=script&lang=ts&"
import style0 from "./SmOption.vue?vue&type=style&index=0&id=3d3f5b5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3f5b5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
